import { useContext } from 'react';

import snackBarContext from 'pages/components/SnackBarProvider/contexts/snack-bar-context';

export default function useNotify() {
    return useContext(snackBarContext);
}
